import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import Overlay from '../../Miscelania/Overlay';
import { Tabs, Tab, Dropdown, MenuItem } from 'react-bootstrap';
import InputMask from 'react-input-mask';
import Select from 'react-select';

import { Modal } from 'react-bootstrap';
import TrainingsCertificationModalEditInstructorsTab from './TrainingsCertificationModalEditInstructorsTab';
import TrainingsCertificationModalEditExaminersTab from './TrainingsCertificationModalEditExaminersTab';
import getLocale from '../../../i18n/getLocale';

class TrainingCertificationLogbooksModal extends Component {
  constructor(props) {
    super(props);

    this.locale = getLocale();

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      modal: false,
      staff_id: null,
      type: null,
      staff_list: [],
      training_certification_logbook_staffs: [],
      types_select: [
        {value: 'examiner', label: this.locale.Treinamentos.EditarTreinamento.tabLogbook.opcoesTipo.Examinador},
        {value: 'instructor', label: this.locale.Treinamentos.EditarTreinamento.tabLogbook.opcoesTipo.Instrutor},
        {value: 'pilot_flying', label: this.locale.Treinamentos.EditarTreinamento.tabLogbook.opcoesTipo.PilotFlying},
        {value: 'pilot_monitoring', label: this.locale.Treinamentos.EditarTreinamento.tabLogbook.opcoesTipo.PilotMonitoring},
      ],
    };
    //handlers

    this.add = this.add.bind(this);
    this.delete = this.delete.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  // Handlers
  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  //LM
  componentWillReceiveProps(newProps) {
    if (newProps.modal_props === true && this.state.loaded === 0) {
      this.setState({
        modal: true,
        id: newProps.training_certification_logbook.id,
        training_certification_logbook_id: newProps.training_certification_logbook.id,
        training_certification_logbook_staffs: newProps.training_certification_logbook_staffs,
        staff_list: newProps.staff_list,
        loaded: 1,
      });
    }
  }

  // Fetch salvando a edição
  add (event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      training_certification_logbook_id: this.state.id,
      staff_id: this.state.staff_id,
      type: this.state.type,
    };

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/certificado/logbook/tripulante', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({
          training_certification_logbook_staffs: responseJson.data,
        });
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  delete(id) {
    if (window.confirm(this.locale.Treinamentos.EditarTreinamento.tabLogbook.deletarTripulante)) {
      this.props.handleAlert('', '', 'open');

      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/treinamento/certificado/logbook/tripulante/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({
            training_certification_logbook_staffs: responseJson.data,
          });
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  closeModal() {
    this.setState({
      modal: false,
      loaded: 0,
    }, this.props.closeModalParent());
  }

  render() {
    var self = this;
    return (
      <div>
        <RequestApi ref={'request_api'} />
        <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
        <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
          <Modal.Header>
            <h4 className="pull-left">{this.locale.Treinamentos.EditarTreinamento.tabLogbook.tituloAdicionarTripulante}</h4>
            <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModal}>
            <i className="fa fa-fw fa-close"></i></button>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={this.add}>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.Treinamentos.EditarTreinamento.tabLogbook.formularioAdicionarTripulante.Tripulante}:</label>
                    <Select
                      className="form-field-name"
                      name="staff_id"
                      value={this.state.staff_id}
                      searchable={true}
                      placeholder={''}
                      onChange={this.handleSelectChange.bind(this, 'staff_id')}
                      options={this.state.staff_list}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.Treinamentos.EditarTreinamento.tabLogbook.formularioAdicionarTripulante.Tipo}:</label>
                    <Select
                      className="form-field-name"
                      name="type"
                      value={this.state.type}
                      searchable={true}
                      placeholder={''}
                      onChange={this.handleSelectChange.bind(this, 'type')}
                      options={this.state.types_select}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.general.salvar}</button>
                </div>
              </div>
            </form>
            <hr/>
            <table className="table table-bordered table-hover">
              <thead>
                <tr>
                  <th className="text-center">{this.locale.Treinamentos.EditarTreinamento.tabLogbook.tabelaAdicionarTripulante.Tripulante}</th>
                  <th className="text-center">{this.locale.Treinamentos.EditarTreinamento.tabLogbook.tabelaAdicionarTripulante.Matricula}</th>
                  <th className="text-center">{this.locale.Treinamentos.EditarTreinamento.tabLogbook.tabelaAdicionarTripulante.Tipo}</th>
                  <th className="text-center">{this.locale.Treinamentos.EditarTreinamento.tabLogbook.tabelaAdicionarTripulante.Acoes}</th>
                </tr>
              </thead>
              <tbody id="training-certification-staffs">
                {Object.keys(self.state.training_certification_logbook_staffs).map(function(k) {
                  return (
                    <tr>
                      <td className="text-center">{self.state.training_certification_logbook_staffs[k].staff.name}</td>
                      <td className="text-center">{self.state.training_certification_logbook_staffs[k].staff.inscription}</td>
                      <td className="text-center">{self.state.training_certification_logbook_staffs[k].type_str}</td>
                      <td className="col-md-2 text-center">
                        <button className="btn btn-danger btn-sm" onClick={() => self.delete(self.state.training_certification_logbook_staffs[k].id)}>
                          <i className="fa fa-fw fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModal}>
            <i className="fa fa-fw fa-close"></i></button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default TrainingCertificationLogbooksModal;



// WEBPACK FOOTER //
// ./src/Components/Trainings/Elements/TrainingCertificationLogbooksModal.js